/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import 'tooltipster/dist/css/tooltipster.bundle.min.css';
import 'tooltipster/dist/js/tooltipster.bundle.min.js';
import 'tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-shadow.min.css';

import './temperatures-table.scss';

/* eslint-disable import/no-unresolved, import/default */

import temperaturesTableTemplate from './temperatures-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import tinycolor from "tinycolor2";

export default angular.module('agrolog.client.temperaturesTable', [])
    .directive('agTemperaturesTable', TemperaturesTable)
    .name;

const tempLimitInterval = 4;

/*@ngInject*/
function TemperaturesTable() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            telemetryType: '<',
            maxTemperature: '=',
            minTemperature: '=',
            sensorLines: '=',
            enabledSensorsAttr: '=',
            temperaturePrefix: '@',
            tableVisible: '@',
            onSensorDataHistory: '&',
            onSensorsData: '&',
            onSensorSelected: '&',
            absolute: '='
        },
        controller: TemperaturesTableController,
        controllerAs: 'vm',
        templateUrl: temperaturesTableTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function TemperaturesTableController($scope, $element, $log, $translate, $filter, $compile, unitService, agTypes, types) {

    let vm = this;
    vm.agTypes = agTypes;

    vm.tempStatCablesLoading = true;

    vm.temperaturesTableBody = null;
    vm.temperaturesTableHeader = null;

    if (vm.telemetryType === agTypes.telemetry.type.temperature) {
        vm.telemetryColors = agTypes.colors.tempMatrixColors;
    } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
        vm.telemetryColors = agTypes.colors.moistureMatrixColors;
    } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
        vm.telemetryColors = agTypes.colors.co2MatrixColors;
    }

    $scope.tempsTableInitWatch = $scope.$watch(function() {
        return angular.element('md-list.ag-temperatures-table', $element).length;
    }, function (length) {
        if (length) {
            $scope.tempsTableInitWatch();
            var temperaturesTable = angular.element('md-list.ag-temperatures-table', $element);
            vm.temperaturesTableHeader = angular.element('.ag-header-wrapper', temperaturesTable);
            vm.temperaturesTableBody = angular.element('#temperatures-table-body', temperaturesTable);
            vm.temperaturesTableHeader.css({width: 'auto'});
            vm.temperaturesTableBody.scroll(function() {
                var width = vm.temperaturesTableBody.width() + vm.temperaturesTableBody[0].scrollLeft + 'px';
                var left = -vm.temperaturesTableBody[0].scrollLeft + 'px';
                vm.temperaturesTableHeader.css({
                    left: left,
                    width: width
                });
            });
        }
    });

    vm.tempStatSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onTempStatDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: function(subscription) {
                vm.tempStatCablesLoading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    vm.telemetryLimits = [];
    let displayCounter = 0;

    vm.telemetrySymbol = telemetrySymbol;
    vm.tempColor = tempColor;
    vm.tempBackgroundColor = tempBackgroundColor;
    vm.onSensorClick = onSensorClick;
    vm.tempsTableWidth = tempsTableWidth;

    vm.maxTempLimit = maxTempLimit;
    vm.avgTempLimit = avgTempLimit;
    vm.minTempLimit = minTempLimit;

    vm.sensorDataHistoryClick = sensorDataHistoryClick;

    $scope.$watch('vm.tableVisible', function() {
        if (vm.tableVisible === 'true') {
            displayCounter = displayCounter + 1;

            if (displayCounter === 1) {
                $scope.$watch('vm.sensorLines', function () {
                    subscribeToSensorLinesData();
                });
            }
        }
    });

    $scope.$watch('vm.maxTemperature', function() {
        vm.telemetryLimits = [];
        var maxTemperature = vm.maxTemperature;
        var minTemperature = vm.minTemperature;
        var tempLimitStep = (maxTemperature - minTemperature) / tempLimitInterval;
        for (var t=minTemperature;t<=maxTemperature;t+=tempLimitStep) {
            vm.telemetryLimits.push(t);
        }
    });

    function subscribeToSensorLinesData() {
        if (vm.sensorLines) {
            reset();
            vm.tempStatCablesLoading = true;
            var sensorLinesSubscriptionsInfo = [];

            for (let i=0; i<vm.sensorLines.length; i++) {
                var sensorLine = vm.sensorLines[i];
                vm.tempSensorsCount = Math.max(vm.tempSensorsCount, sensorLine.sensorCount);

                const fetchErrorValues = (
                    vm.temperaturePrefix === agTypes.telemetry.sensorLines.temperaturePrefix ||
                    vm.temperaturePrefix === agTypes.telemetry.sensorLines.moisturePrefix ||
                    vm.temperaturePrefix === agTypes.telemetry.sensorLines.co2Prefix
                );
                sensorLinesSubscriptionsInfo.push(createTempSubscriptionInfoFromSensorLine(sensorLine, fetchErrorValues));
            }

            if (!vm.enabledSensorsAttr) {
                vm.enabledSensors = createDefaultEnabledSensors();
            } else {
                vm.enabledSensors = angular.fromJson(vm.enabledSensorsAttr);
                for (var col=0;col<vm.sensorLines.length;col++) {
                    sensorLine = vm.sensorLines[col];
                    if (!vm.enabledSensors[sensorLine.id.id]) {
                        vm.enabledSensors[sensorLine.id.id] = [];
                        for (var sensorId=0;sensorId<sensorLine.sensorCount;sensorId++) {
                            vm.enabledSensors[sensorLine.id.id].push(sensorId);
                        }
                    }
                }
                for (var sensorLineId in vm.enabledSensors) {
                    var result = $filter('filter')(vm.sensorLines, {id: {id: sensorLineId }}, true);
                    if (!result || !result.length) {
                        delete vm.enabledSensors[sensorLineId];
                    }
                }
            }

            var index = 0;
            for (var c=0;c<vm.sensorLines.length;c++) {
                sensorLine = vm.sensorLines[c]
                for (var s = 0; s < sensorLine.sensorCount; s++) {
                    vm.tempSensorsDataIndexes[c * vm.tempSensorsCount + s] = index;
                    index++;
                }
            }

            if (sensorLinesSubscriptionsInfo.length > 0) {
                vm.tempStatSubscriptionOptions.timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
                vm.tempStatSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
                vm.tempStatSubscriptionOptions.timeWindowConfig.aggregation.limit = 1;
                vm.ctx.subscriptionApi.createSubscriptionFromInfo (
                    types.widgetType.timeseries.value, sensorLinesSubscriptionsInfo, vm.tempStatSubscriptionOptions, false, true).then(
                    function(subscription) {
                        vm.tempStatSubscription = subscription;
                    }
                );
            }
        }
    }

    $scope.$on('dashboardTimewindowChanged', function (event, newDashboardTimewindow) {
        if (vm.tempStatSubscription) {
            var newTimewindowConfig = angular.copy(newDashboardTimewindow);
            newTimewindowConfig.aggregation.type = types.aggregation.none.value;
            newTimewindowConfig.aggregation.limit = 1;
            vm.tempStatSubscription.timeWindowConfig = newTimewindowConfig;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function createDefaultEnabledSensors() {
        var enabledSensors = {};
        for (var col=0;col<vm.sensorLines.length;col++) {
            var sensorLine = vm.sensorLines[col];
            enabledSensors[sensorLine.id.id] = [];
            for (var sensorId=0;sensorId<sensorLine.sensorCount;sensorId++) {
                enabledSensors[sensorLine.id.id].push(sensorId);
            }
        }
        return enabledSensors;
    }

    function reset() {
        if (vm.tempStatSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.tempStatSubscription.id);
        }
        vm.tempSensorsCount = 0;
        vm.tempSensorsDataIndexes = [];
        vm.tempSensorsData = [];
        if (vm.temperaturesTableHeader) {
            vm.temperaturesTableHeader.css({width: 'auto'});
        }
    }

    function createTempSubscriptionInfoFromSensorLine(sensorLine, fetchErrorValues) {
        var subscriptionInfo = {
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: sensorLine.id.id,
            entityName: sensorLine.name,
            timeseries: []
        };

        for (let i=0;i<sensorLine.sensorCount;i++) {
            if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.temperaturePrefix
                || vm.temperaturePrefix === agTypes.telemetry.sensorLines.deltaTemperaturePrefix) {
                const timeseriesKey = {
                    name: vm.temperaturePrefix+(i+1),
                    label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                    + $translate.instant('ag.silo.temperature') +' ' + (i+1)
                };
                subscriptionInfo.timeseries.push(timeseriesKey);
            } else if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.moisturePrefix
                || vm.temperaturePrefix === agTypes.telemetry.sensorLines.deltaMoisturePrefix) {
                const timeseriesKey = {
                    name: vm.temperaturePrefix+(i+1),
                    label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                    + $translate.instant('ag.silo.moisture') +' ' + (i+1)
                };
                subscriptionInfo.timeseries.push(timeseriesKey);
            } else if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.co2Prefix
                || vm.temperaturePrefix === agTypes.telemetry.sensorLines.deltaCO2Prefix) {
                const timeseriesKey = {
                    name: vm.temperaturePrefix+(i+1),
                    label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                        + $translate.instant('ag.co2.co2') +' ' + (i+1)
                };
                subscriptionInfo.timeseries.push(timeseriesKey);
            }

            if (fetchErrorValues) {
                if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.temperaturePrefix) {
                    const tempTimeseriesKey = {
                        name: agTypes.telemetry.sensorLines.temperatureErrorPrefix+(i+1),
                        label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                            + $translate.instant('ag.silo.temperature') +' ' + (i+1)
                    };
                    subscriptionInfo.timeseries.push(tempTimeseriesKey);
                } else if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.moisturePrefix) {
                    const moistureTimeseriesKey = {
                        name: agTypes.telemetry.sensorLines.moistureErrorPrefix+(i+1),
                        label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                            + $translate.instant('ag.silo.moisture') +' ' + (i+1)
                    };
                    subscriptionInfo.timeseries.push(moistureTimeseriesKey);
                } else if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.co2Prefix) {
                    const moistureTimeseriesKey = {
                        name: agTypes.telemetry.sensorLines.co2ErrorPrefix+(i+1),
                        label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                            + $translate.instant('ag.co2.co2') +' ' + (i+1)
                    };
                    subscriptionInfo.timeseries.push(moistureTimeseriesKey);
                }
                
            }
        }

        return subscriptionInfo;
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    function onTempStatDataUpdated(subscription, apply) {

        var data = angular.copy(subscription.data);

        if (vm.latestData && angular.equals(vm.latestData, data)) {
            return;
        } else {
            vm.latestData = angular.copy(data);
        }

        let errorData = [];
        let nonErrorData = data;
        let useErrorData = false;

        if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.temperaturePrefix) {
            useErrorData = true;
            errorData = data?.filter((item) => item?.dataKey?.name?.startsWith(agTypes.telemetry.sensorLines.temperatureErrorPrefix)) ?? [];
            nonErrorData = data?.filter((item) => !item?.dataKey?.name?.startsWith(agTypes.telemetry.sensorLines.temperatureErrorPrefix)) ?? [];
        } else if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.moisturePrefix) {
            useErrorData = true;
            errorData = data?.filter((item) => item?.dataKey?.name?.startsWith(agTypes.telemetry.sensorLines.moistureErrorPrefix)) ?? [];
            nonErrorData = data?.filter((item) => !item?.dataKey?.name?.startsWith(agTypes.telemetry.sensorLines.moistureErrorPrefix)) ?? [];
        } else if (vm.temperaturePrefix === agTypes.telemetry.sensorLines.co2Prefix) {
            useErrorData = true;
            errorData = data?.filter((item) => item?.dataKey?.name?.startsWith(agTypes.telemetry.sensorLines.co2ErrorPrefix)) ?? [];
            nonErrorData = data?.filter((item) => !item?.dataKey?.name?.startsWith(agTypes.telemetry.sensorLines.co2ErrorPrefix)) ?? [];
        }
        if (useErrorData) {
            if (errorData.length !== nonErrorData.length) {

                $log.error(`The error (${errorData.length}) vs Non-Error (${nonErrorData.length}) sensors number does not match.`);
                $log.error(`Error Telemetries: ${angular.toJson(errorData)}`);
                $log.error(`Non-Error Telemetries: ${angular.toJson(nonErrorData)}`);

            } else {
                for (var i = 0; i < errorData.length; i++) {
                    if (errorData[i].data.length) {
                        if (!nonErrorData[i].data.length) {
                            nonErrorData[i].data = errorData[i].data;
                        } else {
                            if (errorData[i].data[0] > nonErrorData[i].data[0]) {
                                nonErrorData[i].data = errorData[i].data;
                            }
                        }
                    }
                }
            }
        }

        vm.tempSensorsData = [];
        for (var row=0;row<vm.tempSensorsCount;row++) {
            var sensorRow = {
                sensorName: $translate.instant('ag.silo.sensor') + ' ' + (row + 1),
                data: []
            }
            for (var col=0;col<vm.sensorLines.length;col++) {
                var index = vm.tempSensorsDataIndexes[col*vm.tempSensorsCount+row];
                var sensorValue = '';
                var sensorDisplayValue = '';
                var sensorValueTs = '';
                if (angular.isDefined(index) && nonErrorData && nonErrorData[index]) {
                    var val = getNumberValue(nonErrorData[index]);
                    if (val != null) {
                        if (val === '' || val <= -99) {
                            sensorValue = 'E';
                            sensorDisplayValue = sensorValue;
                        } else {
                            sensorValue = vm.ctx.utils.formatValue(val, 1, '');
                            sensorDisplayValue = (vm.telemetryType === agTypes.telemetry.type.temperature) ? vm.ctx.utils.formatValue(unitService.toUserTemperature(val, vm.absolute), 1, '') : sensorValue;
                        }
                    }
                    sensorValueTs = getFormattedTs(nonErrorData[index]);
                }
                sensorRow.data.push(
                    {
                        value: sensorValue,
                        displayValue: sensorDisplayValue,
                        tsValue: sensorValueTs
                    }
                );
            }
            vm.tempSensorsData.push(sensorRow);
        }

        if (vm.onSensorsData) {
            var sensorsData = {};
            for (var c=0;c<vm.sensorLines.length;c++) {
                let currentSensorLine = vm.sensorLines[c];
                var lineNum = currentSensorLine.lineNum;
                var moistureSensors = angular.fromJson(currentSensorLine.moistureSensors);
                if (moistureSensors) {
                    var moistureNumbers = moistureSensors.sensorNumbers;
                }

                var co2Sensors = angular.fromJson(currentSensorLine.co2Sensors);
                if (co2Sensors) {
                    var co2Numbers = co2Sensors.sensorNumbers;
                }

                var tempValues = [];
                for (var r=0;r<vm.tempSensorsCount;r++) {
                    var value = vm.tempSensorsData[r].data[c].value;
                    if (vm.telemetryType === agTypes.telemetry.type.temperature) {
                        if (value !== '' && value !== 'E') {
                            value = Number(value);
                        } else {
                            value = null;
                        }
                    } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
                        if (moistureNumbers && moistureNumbers.length && moistureNumbers.indexOf(r + 1) !== -1 ) {
                            if (value !== '' && value !== 'E') {
                                value = Number(value);
                            } else {
                                value = null;
                            }
                        } else {
                            value = 'T';
                        }
                    } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
                        if (co2Numbers && co2Numbers.length && co2Numbers.indexOf(r + 1) !== -1 ) {
                            if (value !== '' && value !== 'E') {
                                value = Number(value);
                            } else {
                                value = null;
                            }
                        } else {
                            value = 'C';
                        }
                    }
                    tempValues[r] = value;
                }
                sensorsData[lineNum] = tempValues;
            }
            vm.onSensorsData({ sensorsData: sensorsData });
        }
        vm.tempSensorsData.reverse();

        if (apply) {
            $scope.$digest();
        }
    }

    function getNumberValue(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][1])) {
            if (!isNaN(keyData.data[0][1])) {
                return Number(keyData.data[0][1]);
            } else {
                return '';
            }
        } else {
            return null;
        }
    }

    function getFormattedTs(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][0])) {
            if (!isNaN(keyData.data[0][0])) {
                var ts = Number(keyData.data[0][0]);
                return $filter('date')(ts, 'yyyy-MM-dd HH:mm:ss');
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    function isSensorDisabled(row, col) {
        if (!vm.sensorLines[col]) return false;
        var sensorLineId = vm.sensorLines[col].id.id;
        var lineEnabledSensors = vm.enabledSensors[sensorLineId];
        var sensorId = vm.tempSensorsCount - row - 1;
        return lineEnabledSensors.indexOf(sensorId) <= -1;
    }

    function telemetrySymbol() {
        if (vm.telemetryType === agTypes.telemetry.type.temperature) {
            return unitService.temperatureUnitSymbol();
        } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
            return unitService.moistureUnitSymbol();
        } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
            return unitService.co2UnitSymbol();
        }
    }

    function tempColor(sensorValue, row, col) {
        if (isSensorDisabled(row, col)) {
            return '#555';
        } else {
            return 'inherit';
        }
    }

    function onSensorClick($event, sensorValueData, row, col) {
        displaySensorValueTooltip($event, sensorValueData, row, col);
        if (vm.onSensorSelected) {
            let lineNum = vm.sensorLines[col].lineNum;
            let sensorIndex = vm.tempSensorsCount - row - 1;
            vm.onSensorSelected({lineNum: lineNum, sensorIndex: sensorIndex});
        }
    }

    function displaySensorValueTooltip($event, sensorValueData, row, col) {
        var instances = angular.element.tooltipster.instances();
        instances.forEach((instance) => {
            instance.destroy();
        });
        var element = angular.element($event.target);
        element.tooltipster(
            {
                theme: 'tooltipster-shadow',
                delay: 100,
                trigger: 'custom',
                triggerOpen: {
                    click: false,
                    tap: false
                },
                triggerClose: {
                    click: true,
                    tap: true,
                    scroll: true
                },
                trackOrigin: true
            }
        );
        var temperatureBackgroundColor = tempBackgroundColor(sensorValueData.value, row, col);
        var temperatureColor = tempColor(sensorValueData.value, row, col);
        var temp = sensorValueData.displayValue;
        if (temp.length && temp !== 'E') {
            const telemetryUnit = telemetrySymbol();
            temp += telemetryUnit;
        }
        var cableName;
        if (vm.sensorLines[col].type === vm.agTypes.deviceType.temperatureSensorLines) {
            cableName = 'T'+vm.sensorLines[col].lineNum;
        } else if (vm.sensorLines[col].type === vm.agTypes.deviceType.moistureSensorLines) {
            cableName = 'M'+vm.sensorLines[col].lineNum;
        } else if (vm.sensorLines[col].type === vm.agTypes.deviceType.co2SensorLines) {
            cableName = 'C'+vm.sensorLines[col].lineNum;
        }
        var sensorName = vm.tempSensorsData[row].sensorName;
        var contentElement = angular.element('<div class="ag-temp-cell-tooltip">' +
            '<a class="ag-temp-cell-tooltip-close-button" id="close" style="outline: none;">×</a>' +
            '<div id="tooltip-content" layout="column">' +
            '<div class="ag-temp-title" layout="row" layout-align="center center">' +
                '<div class="ag-cable"><span ng-class="{\'ag-hum-cable\': vm.sensorLines['+col+'].type == vm.agTypes.deviceType.moistureSensorLines, \'ag-co2-cable\': vm.sensorLines['+col+'].type == vm.agTypes.deviceType.co2SensorLines}">'+cableName+'</span></div>' +
                '<span style="width: 25px;"></span>' +
                '<div class="ag-sensor">'+sensorName+'</div>' +
            '</div>'+
            '<div class="ag-temp-ts">'+sensorValueData.tsValue+'</div>'+
            '<div layout="column" layout-align="center center">' +
                '<div class="ag-temp-value" style="color: '+temperatureColor+'; ' +
                        'background-color: '+temperatureBackgroundColor+';">'+temp+'</div>'+
                '</div>' +
                '<a class="ag-sensor-data-history-link" ng-click="vm.sensorDataHistoryClick($event, '+col+', '+row+')">'+$translate.instant('ag.silo.sensor-data-history')+'</a>' +
            '</div>' +
            '</div>');
        $compile(contentElement)($scope);
        var tooltip = element.tooltipster('instance');
        contentElement.find('#close').on('click', function() {
            tooltip.destroy();
        });
        tooltip.content(contentElement);
        tooltip.open();
    }

    function sensorDataHistoryClick($event, col, row) {
        var lineNum = vm.sensorLines[col].lineNum;
        var sensorIndex = vm.tempSensorsCount - row - 1;
        if (vm.onSensorDataHistory) {
            vm.onSensorDataHistory({lineNum: lineNum, sensorIndex: sensorIndex});
        }
    }

    function tempBackgroundColor(sensorValue, row, col) {
        if (sensorValue === 'E') {
            return agTypes.colors.errorValueColor;
        } else if (!sensorValue.length) {
            return 'transparent';
        } else {
            var color;
            if (isSensorDisabled(row, col)) {
                color = tinycolor('#777');
            } else {
                var val = Number(sensorValue);
                if (val <= vm.telemetryLimits[0]) {
                    color = tinycolor(vm.telemetryColors[0]);
                } else if (val >= vm.telemetryLimits[vm.telemetryLimits.length - 1]) {
                    color = tinycolor(vm.telemetryColors[vm.telemetryColors.length - 1]);
                } else {
                    var firstIndex;
                    var secondIndex;
                    for (var i = 0; i < vm.telemetryLimits.length; i++) {
                        if (val <= vm.telemetryLimits[i + 1]) {
                            firstIndex = i;
                            secondIndex = i + 1;
                            break;
                        }
                    }
                    var firstColor = vm.telemetryColors[firstIndex];
                    var secondColor = vm.telemetryColors[secondIndex];
                    var percent = ((val - vm.telemetryLimits[firstIndex]) /
                        (vm.telemetryLimits[secondIndex] - vm.telemetryLimits[firstIndex])) * 100;
                    color = tinycolor.mix(firstColor, secondColor, percent);
                }
            }
            return color.setAlpha(0.75).toRgbString();
        }
    }

    function tempsTableWidth() {
        var hasScroll = false;
        if (vm.temperaturesTableBody) {
            hasScroll = vm.temperaturesTableBody[0].scrollHeight > vm.temperaturesTableBody[0].clientHeight;
        }
        var result = 16 + 70 + (vm.sensorLines ? vm.sensorLines.length : 0) * 30;
        if (hasScroll) {
            result += 15;
        }
        return result;
    }

    function maxTempLimit() {
        if (vm.telemetryLimits.length) {
            var limit = vm.telemetryLimits[vm.telemetryLimits.length-1];
            return (vm.telemetryType === agTypes.telemetry.type.temperature) ? unitService.toUserTemperature(limit, vm.absolute) : limit;
        }
    }

    function avgTempLimit() {
        if (vm.telemetryLimits.length) {
            var limit = vm.telemetryLimits[tempLimitInterval/2];
            return (vm.telemetryType === agTypes.telemetry.type.temperature) ? unitService.toUserTemperature(limit, vm.absolute) : limit;
        }
    }

    function minTempLimit() {
        if (vm.telemetryLimits.length) {
            var limit = vm.telemetryLimits[0];
            return (vm.telemetryType === agTypes.telemetry.type.temperature) ? unitService.toUserTemperature(limit, vm.absolute) : limit;
        }
    }
}
